import { connect } from 'react-redux';
import { get } from 'lodash';

import { isUserLoggedIn } from 'apps/user/helpers';
import MyAccount from '../components/MyAccount';

export default connect(state => ({
  accountLinks: state.topNavigation.links.account,
  isLoggedIn: isUserLoggedIn(state.user),
  profilePictureUrl: get(state.user, 'customerDetails.profilePicture', null),
}))(MyAccount);
